import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

function ImagePreview({ data, selectedImage, setselectedImage, setopen, apiImage }: any) {
  const selectImage = (e: any) => {
    setselectedImage(e);
  };

  return (
    <div className="fixed inset-0 bg-black/90 z-50 flex flex-col">
      {/* Header */}
      <div className="flex justify-end p-4">
        <button
          onClick={() => setopen(false)}
          className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
        >
          <CloseIcon />
        </button>
      </div>

      {/* Main Image */}
      <div className="flex-1 flex items-center justify-center p-4">
        <img
          src={selectedImage}
          alt="Preview"
          className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
        />
      </div>

      {/* Thumbnails */}
      <div className="p-4 bg-black/50">
        <div className="flex items-center justify-center gap-4">
          <button className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors">
            <ArrowBackIosIcon sx={{ fontSize: 18 }} />
          </button>

          <div className="flex gap-2 overflow-x-auto max-w-2xl py-2">
            {apiImage?.map((image: any, i: number) => (
              <img
                key={i}
                src={`${process.env.REACT_APP_API}${image.imageUrl}`}
                alt={`X-ray ${image._id}`}
                onClick={() => selectImage(`${process.env.REACT_APP_API}${image.imageUrl}`)}
                className={`w-16 h-16 object-cover rounded-lg cursor-pointer transition-all ${
                  selectedImage === `${process.env.REACT_APP_API}${image.imageUrl}`
                    ? "ring-2 ring-indigo-500 scale-110"
                    : "opacity-60 hover:opacity-100"
                }`}
              />
            ))}
            {data?.map((item: any, i: number) => (
              <img
                key={`local-${i}`}
                src={item.url}
                alt=""
                onClick={() => selectImage(item.url)}
                className={`w-16 h-16 object-cover rounded-lg cursor-pointer transition-all ${
                  selectedImage === item.url
                    ? "ring-2 ring-indigo-500 scale-110"
                    : "opacity-60 hover:opacity-100"
                }`}
              />
            ))}
          </div>

          <button className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors">
            <ArrowForwardIosIcon sx={{ fontSize: 18 }} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default ImagePreview;
